import { useState, useEffect, useContext } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Box, Paper, TextField, Tooltip, IconButton, Grid, MenuItem } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api, showWarning } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"
import Save from "@mui/icons-material/Save"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const StyledRoot = {
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: "20px",
  backgroundColor: "#f5f7fa",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
}

const EditarTiposdeCompromiso = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { selectedMenuInfo } = useContext(GlobalContext)

  const [formData, setFormData] = useState({
    tipocompromiso: "",
    tipocomdescri: "",
    tipcomstatus: "A",
  })

  // Cargar los datos al abrir la pantalla desde el state de la ruta
  useEffect(() => {
    if (location.state) {
      setFormData(location.state)
    } else {
      navigate("/home/dashboard/TiposdeCompromiso")
    }
  }, [location, navigate])

  // Mutación para actualizar
  const { mutateAsync: SaveEdicion, isPending: isSaving } = useMutation({
    queryKey: ["isUpdatingTipoCompromiso"],
    fn: async (data) => {
      const response = await api.post("/TiposdeCompromiso/updateTiposdeCompromiso", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1),
  })

  const handleInputChange = (field, value) => {
    let finalValue = value

    // Restricciones de longitud según estructura de tabla SQL
    if (field === "tipocomdescri") {
      finalValue = value.toUpperCase().slice(0, 60)
    }

    setFormData((prev) => ({ ...prev, [field]: finalValue }))
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault()
    try {
      if (!formData.tipocomdescri.trim()) {
        showWarning("La descripción es obligatoria")
        return
      }

      await SaveEdicion(formData)
    } catch (error) {
      console.error("Error al actualizar el Tipo de Compromiso:", error)
    }
  }

  // Lógica dinámica de botones según permisos
  const action = selectedMenuInfo?.data?.barraAcciones?.find(
    (a) => a?.acccaption === "ACTUALIZAR" || a?.acccaption === "GUARDAR" || a?.acccaption === "GRABAR",
  )

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        {/* Barra de Herramientas */}
        <Box sx={{ mb: 2 }}>
          <Tooltip title={action?.acccaption || "Guardar"}>
            <IconButton
              onClick={handleSubmit}
              disabled={isSaving}
              sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, bgcolor: "white" }}
            >
              {action ? getIconComponent(action.accnameicono, action.acctipoico) : <Save />}
            </IconButton>
          </Tooltip>
        </Box>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Editar Tipo de Compromiso: {formData.tipocompromiso}</b>
        </div>

        <CustomBackdrop isLoading={isSaving} />

        <Box sx={StyledRoot}>
          <Paper
            elevation={3}
            sx={{ p: 3, mb: 3, borderRadius: 3, background: "white" }}
            component="form"
            onSubmit={handleSubmit}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Código"
                  value={formData.tipocompromiso}
                  disabled // Bloqueado: Es la llave primaria
                />
              </Grid>

              <Grid item xs={12} sm={9}>
                <TextField
                  fullWidth
                  label="Descripción *"
                  value={formData.tipocomdescri}
                  onChange={(e) => handleInputChange("tipocomdescri", e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Estado"
                  value={formData.tipcomstatus}
                  onChange={(e) => handleInputChange("tipcomstatus", e.target.value)}
                >
                  <MenuItem value="A">ACTIVO</MenuItem>
                  <MenuItem value="I">INACTIVO</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default EditarTiposdeCompromiso
